// import cfg from 'cfg';
// import { requestAsync, httpMethods, UPDATE_DEFAULT } from 'dash-front/requery/actions';
import {
    LOAD_DEFAULT_PPI_WEIGHTS,
    CHANGE_PPI_TABLE_ITEM,
    PPI_TABLE,
    ADD_PPI_TABLE_ROW,
    DELETE_PPI_TABLE_ROW,
    LOAD_DEFAULT_TABLE_ROW_VISIBLE_LIST
} from './constants';
import { POST } from '../constants';
// import { SET, DELETE, POST, GENERATE } from '../constants';

export const toIdArray = ar => ar.reduce((acc, el) => (el.id ? acc.concat(el.id) : acc), []);

export function postPpiTable() {
    return {
        type: POST + PPI_TABLE
    };
}

export function loadDefaultPpiWeights(playersWeights) {
    return {
        type: LOAD_DEFAULT_PPI_WEIGHTS,
        payload: { playersWeights }
    };
}

export function loadDefaultTableRowVisibleList(list) {
    return {
        type: LOAD_DEFAULT_TABLE_ROW_VISIBLE_LIST,
        payload: { list }
    };
}

export function addPpiTableRow(labelRow) {
    return {
        type: ADD_PPI_TABLE_ROW,
        payload: { labelRow }
    };
}

export function deletePpiTableRow(labelRow) {
    return {
        type: DELETE_PPI_TABLE_ROW,
        payload: { labelRow }
    };
}

export function changePpiTableItem(typePlayer, label, value = 0) {
    return {
        type: CHANGE_PPI_TABLE_ITEM,
        payload: { typePlayer, label, value }
    };
}



/** WEBPACK FOOTER **
 ** ../src/dash/front/ppi/actions.js
 **/